// extracted by mini-css-extract-plugin
export default {"root":"W2JBVrkbo7","root_withWeekNumbers":"YeqHwaSHtJ"};